(function () {
  'use strict';

  var debug = (function () {
    try { return !!(window.SWYM_DEBUG || (typeof location !== 'undefined' && /[?&]swymDebug=1/.test(location.search))); } catch (_) { return false; }
  })();
  function log() { try { if (debug) console.log.apply(console, ['[Swym Widgets]'].concat([].slice.call(arguments))); } catch (_) { } }

  function getCountNodes() {
    var override = null; try { override = window.SWYM_WISHLIST_COUNT_SELECTOR; } catch (_) { }
    var defaultSel = '.js-wishlist-count, .m-wishlist-count, .wishlist-h-count, .wishlist-total-count, [data-wishlist-count]';
    var sel = override && String(override).trim() ? override : defaultSel;
    try { return Array.prototype.slice.call(document.querySelectorAll(sel)); } catch (_) { return []; }
  }
  function setHeaderCount(n) {
    var count = typeof n === 'number' ? n : parseInt(n, 10);
    if (isNaN(count)) count = 0;
    var nodes = getCountNodes();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      try { el.textContent = String(count); } catch (_) { }
      try {
        if (count <= 0) {
          el.style.display = 'none';
          el.classList.add('m:hidden');
        } else {
          el.style.display = '';
          el.classList.remove('m:hidden');
        }
      } catch (_) { }
      try {
        el.setAttribute('data-count', String(count));
        el.setAttribute('data-total', String(count));
        if (el.dataset) { el.dataset.count = String(count); el.dataset.total = String(count); }
      } catch (_) { }
    }
    if (debug) log('Header count set to', count, 'nodes:', nodes.length);
  }

  try {
    window.swymWidgets = window.swymWidgets || {};
    window.swymWidgets.setHeaderCount = setHeaderCount;
    window.swymWidgets.updateHeaderCount = function(swat) { updateHeaderCount(swat); };
  } catch (_) { }

  function getListPrefix() { try { return window.SWYM_LIST_PREFIX || null; } catch (_) { return null; } }
  function filterListsByPrefix(arr, prefix) { if (!prefix) return arr || []; return (arr || []).filter(function (l) { var name = (l && (l.name || l.Name || '')) + ''; return name.indexOf(prefix) === 0; }); }

  var swatRef = null;
  function onSwymReady(cb) {
    if (window._swat) { swatRef = window._swat; try { cb(window._swat); } catch (_) { } return; }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) { swatRef = swat; try { cb(swat); } catch (_) { } });
  }

  function initActionButtons(swat) { try { if (swat && typeof swat.initializeActionButtons === 'function') swat.initializeActionButtons('body'); } catch (_) { } }

  function updateHeaderCount(swat) {
    swat = swat || swatRef || window._swat;
    if (!swat) return; 
    var lid = null; try { lid = localStorage.getItem('SWYM_ACTIVE_LID'); } catch (_) { }
    var prefix = getListPrefix();
    if (debug) log('Updating header count (active LID:', lid || 'none', 'prefix:', prefix || 'none', ')');

    var staleCleared = false; 
    function countFromLists(lists) {
      var arr = Array.isArray(lists) ? lists : (lists && Array.isArray(lists.lists) ? lists.lists : []);
      var hadLists = arr.length;
      if (lid) {
        var filtered = arr.filter(function (x) { return (x && (x.lid || x.id || x.LID)) === lid; });
        if (filtered.length === 0 && hadLists > 0 && !staleCleared) {
          try { localStorage.removeItem('SWYM_ACTIVE_LID'); } catch (_) { }
          if (debug) log('Stale active LID removed; retrying header count without LID');
          lid = null; staleCleared = true;
          return countFromLists({ lists: arr });
        }
        arr = filtered;
      } else if (prefix) { arr = filterListsByPrefix(arr, prefix); }
      var seenKeys = {};
      var total = 0;
      for (var i = 0; i < arr.length; i++) {
        var items = (arr[i] && (arr[i].listcontents || arr[i].items || arr[i].Items || arr[i].listItems || (arr[i].contents && arr[i].contents.items))) || [];
        if (Array.isArray(items)) {
          for (var j = 0; j < items.length; j++) {
            var it = items[j];
            if (!it) continue;
            var key = '';
            if (it.empi != null && String(it.empi).trim()) {
              key = 'empi_' + String(it.empi).trim();
            } else if (it.du) {
              key = 'du_' + String(it.du).split('?')[0].replace(/\/+$/, '');
            } else if (it.epi != null) {
              key = 'epi_' + String(it.epi).trim();
            } else if (it.id != null) {
              key = 'id_' + String(it.id).trim();
            }
            if (key) {
              if (!seenKeys[key]) {
                seenKeys[key] = true;
                total++;
              }
            } else {
              total++;
            }
          }
        }
      }
      if (total === 0) {
        tryWishlistCountFallback();
        return;
      }
      setHeaderCount(total);
      if (debug) log('Header count computed as', total, 'from', arr.length, 'lists (deduped)');
    }
    function tryWishlistCountFallback() {
      if (!swat) { setHeaderCount(0); return; }
      var tried = 0; var done = false;
      function handle(val) { if (done) return; done = true; if (debug) log('wishlistCount fallback value', val); if (typeof val === 'number' && val > 0) { setHeaderCount(val); } else { perListFetchFallback(); } }
      function attempt(style) {
        if (done) return; tried++;
        try {
          if (style === 0 && typeof swat.wishlistCount === 'function') { swat.wishlistCount(handle); return; }
          if (style === 1 && typeof swat.wishlistCount === 'function') { swat.wishlistCount({ callbackFn: handle }); return; }
          if (style === 2 && typeof swat.wishlistCount === 'function') { swat.wishlistCount({ successCb: handle }); return; }
        } catch (e) { if (debug) log('wishlistCount style', style, 'error', e); }
        if (tried < 3) attempt(tried); else perListFetchFallback();
      }
      attempt(0);
    }
    function perListFetchFallback() {
      if (!swat || typeof swat.api !== 'function') { setHeaderCount(0); return; }
      swat.api({ method: 'GET', path: '/api/lists' }).then(function (resp) {
        var arr = Array.isArray(resp) ? resp : (resp && resp.lists) || [];
        var total = 0; var pending = 0; var finished = false;
        if (!arr.length) { setHeaderCount(0); return; }
        arr.forEach(function (l) {
          var lidVal = l.lid || l.id || l.LID; if (!lidVal) return;
          pending++;
          swat.api({ method: 'GET', path: '/api/lists/' + lidVal + '?includeListContents=true' })
            .then(function (detail) {
              var items = (detail && (detail.listcontents || detail.items || detail.Items || (detail.contents && detail.contents.items))) || [];
              total += Array.isArray(items) ? items.length : 0;
            })
            .catch(function (err) { if (debug) log('Per-list fetch error', lidVal, err); })
            .finally(function () { pending--; if (pending === 0 && !finished) { finished = true; setHeaderCount(total); if (debug) log('Per-list fallback total', total); } });
        });
      }).catch(function (err) { if (debug) log('perListFetchFallback lists error', err); setHeaderCount(0); });
    }

    if (typeof swat.api === 'function') {
      if (lid) {
        swat.api({ method: 'GET', path: '/api/lists/' + lid + '?includeListContents=true' })
          .then(function (list) { var items = (list && (list.listcontents || list.items || list.Items)) || []; setHeaderCount(Array.isArray(items) ? items.length : 0); })
          .catch(function () { swat.api({ method: 'GET', path: '/api/lists?includeListContents=true' }).then(countFromLists).catch(function () { /* ignore */ }); });
      } else {
        swat.api({ method: 'GET', path: '/api/lists?includeListContents=true' }).then(countFromLists).catch(function () { /* ignore */ });
      }
    } else if (swat.fetchLists) {
      try { swat.fetchLists({ callbackFn: countFromLists }); } catch (_) { }
    }
  }

  function getActiveListLid(swat) {
    swat = swat || window._swat || swatRef;
    return new Promise(function (resolve) {
      var prefix = getListPrefix();
      var stored = null; try { stored = localStorage.getItem('SWYM_ACTIVE_LID'); } catch (_) { }
      var finish = function (lists) {
        var arr = Array.isArray(lists) ? lists : (lists && Array.isArray(lists.lists) ? lists.lists : []);
        var pick = null;
        if (stored) { pick = arr.find(function (l) { return (l && (l.lid || l.id || l.LID)) === stored; }); }
        if (!pick) {
          var filtered = prefix ? filterListsByPrefix(arr, prefix) : arr;
          pick = (filtered.find(function (l) { var items = l && (l.listcontents || l.items || l.listItems || l.contents && l.contents.items); return items && items.length; }) || filtered[0] || arr.find(function (l) { var items = l && (l.listcontents || l.items || l.listItems || l.contents && l.contents.items); return items && items.length; }) || arr[0] || null);
        }
        var lid = pick && (pick.lid || pick.id || pick.LID) || stored || null;
        if (lid) { try { localStorage.setItem('SWYM_ACTIVE_LID', lid); } catch (_) { } }
        resolve(lid);
      };
      try {
        if (swat && typeof swat.api === 'function') {
          swat.api({ method: 'GET', path: '/api/lists' }).then(finish).catch(function () {
            if (swat.fetchLists) { swat.fetchLists({ callbackFn: finish }); } else { resolve(stored); }
          });
        } else if (swat && swat.fetchLists) { swat.fetchLists({ callbackFn: finish }); } else { resolve(stored); }
      } catch (e) { resolve(stored); }
    });
  }

  function scheduleHeaderRefresh() {
    if (!window._swat && !swatRef) return;
    try { updateHeaderCount(); } catch (_) { }
    setTimeout(function () { try { updateHeaderCount(); } catch (_) { } }, 600);
    setTimeout(function () { try { updateHeaderCount(); } catch (_) { } }, 1400);
    setTimeout(function () { try { updateHeaderCount(); } catch (_) { } }, 2400);
  }

  function isAtwAdded(btn) { return btn && (btn.classList.contains('atw-button-added') || btn.classList.contains('swym-added')); }
  function extractAtwIdentifiers(btn) {
    var out = { epi: null, du: null };
    if (!btn) return out;
    try {
      var ds = btn.dataset || {};
      out.epi = ds.epi || ds.variantid || ds.variantId || ds.variant || null;
      out.du = ds.du || ds.url || ds.productUrl || null;
    } catch (_) { }
    if (!out.epi) {
      try { var vMatch = /[?&]variant=(\d+)/.exec(location.search); if (vMatch) out.epi = vMatch[1]; } catch (_) { }
    }
    if (!out.du) {
      try { if (/\/products\//.test(location.pathname)) out.du = location.pathname; } catch (_) { }
    }
    if (out.du && /^https?:/.test(out.du)) {
      try { out.du = new URL(out.du, location.origin).pathname; } catch (_) { }
    }
    if (out.du && out.du.charAt(0) !== '/') out.du = '/' + out.du.replace(/^\/+/, '');
    return out;
  }
  function resolveAtwVariantId(ids) {
    return new Promise(function (resolve) {
      if (ids.epi) return resolve(ids.epi);
      try { var form = document.querySelector('form[action*="/cart"], form[action*="/cart/add"], form[action*="/cart/add.js"], form[action*="/cart/add"]'); if (form) { var iv = form.querySelector('input[name="id"][value]'); if (iv && iv.value) { return resolve(iv.value.trim()); } } } catch (_) { }
      try { var vm = /[?&]variant=(\d+)/.exec(location.search); if (vm) return resolve(vm[1]); } catch (_) { }
      if (ids.du) {
        try {
          var handle = ids.du.split('/products/')[1]; if (handle) { handle = handle.split('?')[0]; }
          if (handle) {
            fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : Promise.reject(); }).then(function (p) {
              var sel = null;
              try { var urlVar = /[?&]variant=(\d+)/.exec(location.search); if (urlVar) { sel = (p.variants || []).find(function (v) { return String(v.id) === urlVar[1]; }); } } catch (_) { }
              if (!sel && Array.isArray(p.variants) && p.variants.length === 1) sel = p.variants[0];
              if (!sel && Array.isArray(p.variants)) sel = p.variants[0];
              if (sel && sel.id) return resolve(String(sel.id));
              throw new Error('No variant in product JSON');
            }).catch(function () { fallbackListLookup(); });
            return; 
          }
        } catch (_) { }
      }
      fallbackListLookup();
      function fallbackListLookup() {
        var swat = window._swat || swatRef;
        if (!swat) { return resolve(null); }
        getActiveListLid(swat).then(function (lid) {
          if (!lid || !swat.api) { return resolve(null); }
          swat.api({ method: 'GET', path: '/api/lists/' + lid + '?includeListContents=true' }).then(function (list) {
            var items = (list && (list.items || list.contents && list.contents.items)) || [];
            var match = items.filter(function (it) { return ids.du && (it.du === ids.du || (it.du || '').split('?')[0] === ids.du); });
            if (match.length === 1) { return resolve(String(match[0].epi || match[0].vi || match[0].id || match[0].EPI)); }
            if (match.length > 1) { return resolve(String(match[0].epi || match[0].vi || match[0].id || match[0].EPI)); }
            resolve(null);
          }).catch(function () { resolve(null); });
        }).catch(function () { resolve(null); });
      }
    });
  }
  function revealWishlistButton() {
  var btn = document.getElementById('swym-atw-pdp-button');
  if (!btn) return;

  function checkReady() {
    var text = btn.querySelector('.atw-button-text');

    if (text && text.textContent.trim() !== '') {
      btn.classList.add('swym-ready');
      return true;
    }

    return false;
  }

  if (checkReady()) return;

  var observer = new MutationObserver(function () {
    if (checkReady()) {
      observer.disconnect();
    }
  });

  observer.observe(btn, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setTimeout(function () {
    btn.classList.add('swym-ready');
    observer.disconnect();
  }, 2000);
}
  function addAtw(btn, ids) {
    var swat = window._swat || swatRef; if (!swat) return;
    resolveAtwVariantId(ids).then(function (epi) {
      if (!epi) { if (debug) log('ATW add aborted: could not resolve variant id'); return; }
      var payload = { epi: epi };
      if (ids.du) payload.du = ids.du;
      getActiveListLid(swat).then(function (lid) { if (lid) payload.lid = lid; proceed(payload); });
      function proceed(payload) {
        var finish = function () {
          try { btn.classList.add('atw-button-added'); btn.classList.add('swym-added'); btn.setAttribute('aria-pressed', 'true'); } catch (_) { }
          try { var txt = btn.querySelector('.atw-button-text'); if (txt) txt.textContent = 'Added to Wishlist'; btn.setAttribute('aria-label', 'Remove from wishlist'); } catch (_) { }
          try {
            var svgIcon = btn.querySelector('#swym-atw-pdp-button-icon, .atw-button-icon, svg');
            if (svgIcon) {
              var path = svgIcon.querySelector('path');
              if (path) {
                path.setAttribute('fill', 'currentColor');
                path.setAttribute('stroke', 'currentColor');
              }
            }
          } catch (_) { }
          try { updateHeaderCount(swat); } catch (_) { }
          scheduleHeaderRefresh();
          try { document.dispatchEvent(new CustomEvent('swym:lists-updated')); } catch (_) { }
          if (debug) log('ATW add done', payload);
        };
        try {
          if (typeof swat.addToWishList === 'function') {
            swat.addToWishList(payload, finish, finish);
          } else if (typeof swat.addToList === 'function' && payload.lid) {
            swat.addToList({ lid: payload.lid, epi: payload.epi, du: payload.du, callbackFn: finish });
          } else { finish(); }
        } catch (e) { finish(); }
      }
    });
  }
  function removeAtw(btn, ids) {
    var swat = window._swat || swatRef; if (!swat) return;
    resolveAtwVariantId(ids).then(function (epi) {
      if (!epi) { if (debug) log('ATW removal aborted: could not resolve variant id'); return; }
      var payload = { epi: epi };
      if (ids.du) payload.du = ids.du;
      getActiveListLid(swat).then(function (lid) { if (lid) payload.lid = lid; proceed(payload); });
      function proceed(payload) {
        var finish = function () {
          try { btn.classList.remove('atw-button-added'); btn.classList.remove('swym-added'); } catch (_) { }
          try { var txt = btn.querySelector('.atw-button-text'); if (txt) txt.textContent = 'Add to Wishlist'; btn.setAttribute('aria-label', 'Add to wishlist'); } catch (_) { }
          try { btn.setAttribute('aria-pressed', 'false'); } catch (_) { }
          try { btn.removeAttribute('disabled'); btn.style.pointerEvents = ''; } catch (_) { }
          try {
            var inner = btn.querySelector('button, [role="button"]');
            if (inner) { inner.removeAttribute('disabled'); inner.setAttribute('aria-pressed', 'false'); }
          } catch (_) { }
          try {
            var svgIcon = btn.querySelector('#swym-atw-pdp-button-icon, .atw-button-icon, svg');
            if (svgIcon) {
              var path = svgIcon.querySelector('path');
              if (path) {
                path.setAttribute('fill', 'none');
                path.setAttribute('stroke', 'currentColor');
              }
            }
          } catch (_) { }
          try { updateHeaderCount(swat); } catch (_) { }
          scheduleHeaderRefresh();
          try { document.dispatchEvent(new CustomEvent('swym:lists-updated')); } catch (_) { }
          try { setTimeout(function () { try { initActionButtons(swat); } catch (_) { } }, 60); } catch (_) { }
          if (debug) log('ATW removal done', payload);
        };
        try {
          if (typeof swat.removeFromWishList === 'function') {
            swat.removeFromWishList(payload, finish, finish);
          } else if (typeof swat.removeFromList === 'function' && payload.lid) {
            swat.removeFromList({ lid: payload.lid, epi: payload.epi, du: payload.du, callbackFn: finish });
          } else { finish(); }
        } catch (e) { finish(); }
      }
    });
  }
  document.addEventListener('click', function (ev) {
    var atwBtn = ev.target.closest && ev.target.closest('#swym-atw-pdp-button');
    if (!atwBtn) return;
    if (isAtwAdded(atwBtn)) {
      ev.preventDefault();
      var ids = extractAtwIdentifiers(atwBtn);
      if (debug) log('ATW button clicked (remove flow)', ids);
      removeAtw(atwBtn, ids);
    } else {
      if (debug) log('ATW button clicked (add flow)');
      var ids2 = extractAtwIdentifiers(atwBtn);
      setTimeout(scheduleHeaderRefresh, 300);
      setTimeout(scheduleHeaderRefresh, 1200);
      setTimeout(function () {
        try {
          if (!isAtwAdded(atwBtn)) {
            if (debug) log('ATW add fallback invoked');
            addAtw(atwBtn, ids2);
          }
        } catch (_) { }
      }, 500);
    }
  }, true);

  try {
    var mo = new MutationObserver(function (muts) {
      var shouldRefresh = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'aria-pressed')) {
          var tgt = m.target;
          if (tgt && tgt.classList && (tgt.classList.contains('swym-add-to-wishlist') || tgt.classList.contains('swym-button') || tgt.classList.contains('swym-wishlist-button') || tgt.id === 'swym-atw-pdp-button')) {
            var wasAdded = tgt.classList.contains('swym-added') || tgt.classList.contains('atw-button-added');
            var wasRemoved = !wasAdded && (m.oldValue && (m.oldValue.indexOf('swym-added') >= 0 || m.oldValue.indexOf('atw-button-added') >= 0));

            try {
              var btn = tgt.id === 'swym-atw-pdp-button' ? tgt : tgt.closest('#swym-atw-pdp-button');
              if (btn) {
                var svgIcon = btn.querySelector('#swym-atw-pdp-button-icon, .atw-button-icon, svg');
                if (svgIcon) {
                  var path = svgIcon.querySelector('path');
                  if (path) {
                    if (wasAdded) {
                      path.setAttribute('fill', 'currentColor');
                      path.setAttribute('stroke', 'currentColor');
                    } else if (wasRemoved) {
                      path.setAttribute('fill', 'none');
                      path.setAttribute('stroke', 'currentColor');
                    }
                  }
                }
              }
            } catch (_) { }

            if (debug && wasAdded) log('Detected swym-added class change, refreshing count');
            shouldRefresh = true; break;
          }
        }
      }
      if (shouldRefresh) {
        try { updateHeaderCount(); } catch (_) { }
        scheduleHeaderRefresh();
      }
    });
    mo.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class', 'aria-pressed'], attributeOldValue: true });
  } catch (_) { }

  setTimeout(function () { if (!window._swat && !swatRef && debug) log('Swym SDK not detected. Enable Swym app embed for wishlist.'); }, 2000);

  onSwymReady(function (swat) {
    if (debug) log('Swym SDK ready');
     revealWishlistButton(); 
    initActionButtons(swat);
    updateHeaderCount(swat);
    setTimeout(function () { updateHeaderCount(swat); }, 1000);
    document.addEventListener('swym:lists-updated', function () {
      if (debug) log('swym:lists-updated event caught, updating count');
      updateHeaderCount(swat);
    });

    try {
      document.addEventListener('swym:button-removed', function () {
        try { initActionButtons(swat); } catch (_) { }
        try {
          var b = document.getElementById('swym-atw-pdp-button');
          if (b) { b.setAttribute('aria-pressed', 'false'); b.removeAttribute('disabled'); }
        } catch (_) { }
      });
    } catch (_) { }

    document.addEventListener('click', function (e) {
      try {
        var btn = e.target.closest('.swym-button, .swym-add-to-wishlist, .swym-wishlist-button, [class*="swym"]');
        if (!btn) return;
        if (debug) log('Swym button clicked, scheduling count update');
        setTimeout(function () { try { updateHeaderCount(swat); } catch (_) { } }, 200);
        setTimeout(function () { try { updateHeaderCount(swat); } catch (_) { } }, 800);
        setTimeout(function () { try { updateHeaderCount(swat); } catch (_) { } }, 1500);
      } catch (_) { }
    }, true);
  });

  setTimeout(function () { updateHeaderCount(); }, 4000);

  var refreshLock = false;
  function safeSchedule() { if (refreshLock) return; refreshLock = true; scheduleHeaderRefresh(); setTimeout(function () { refreshLock = false; }, 500); }

  try {
    document.addEventListener('swym:item-added', safeSchedule);
    document.addEventListener('swym:item-removed', safeSchedule);
    document.addEventListener('swym:wishlist-updated', safeSchedule);
    document.addEventListener('swym:button-added', safeSchedule);
    document.addEventListener('swym:button-removed', safeSchedule);
  } catch (_) { }

  try {
    if (window._swat || swatRef) {
      var swat = window._swat || swatRef;
      if (swat.eventEmitter && typeof swat.eventEmitter.on === 'function') {
        swat.eventEmitter.on('addToWishList', safeSchedule);
        swat.eventEmitter.on('removeFromWishList', safeSchedule);
      }
    }
  } catch (_) { }

  if (!window.__swymToggleSyncInitialized) {
    window.__swymToggleSyncInitialized = true;

    document.addEventListener('click', function(ev) {
      var btn = ev.target.closest && ev.target.closest('.swym-add-to-wishlist-view-product, #swym-quick-view, .m-product-quickview-wishlist-button');
      if (!btn || btn.id === 'swym-atw-pdp-button') return;

      var isAdded = btn.classList.contains('swym-added') || btn.getAttribute('aria-pressed') === 'true';
      var prodId = btn.dataset.productId || btn.getAttribute('data-product-id');
      var variantId = btn.dataset.variantId || btn.getAttribute('data-variant-id');
      var prodUrl = btn.dataset.productUrl || btn.getAttribute('data-product-url');

      if (isAdded) {
        ev.preventDefault();
        ev.stopImmediatePropagation();

        var selector = prodId ? ('.swym-button.product_' + prodId + ', .swym-button[data-product-id="' + prodId + '"]') : null;
        var matchingBtns = selector ? document.querySelectorAll(selector) : [btn];
        matchingBtns.forEach(function(b) {
          b.classList.remove('swym-added');
          b.setAttribute('aria-pressed', 'false');
          if (b.parentElement && b.parentElement.classList.contains('main-product__block-wishlist')) {
            b.parentElement.classList.remove('swym-block-added');
          }
        });

        var countEls = document.querySelectorAll('.js-wishlist-count, .m-wishlist-count, .wishlist-h-count, .wishlist-total-count, [data-wishlist-count]');
        countEls.forEach(function(el) {
          var current = parseInt(el.textContent.trim(), 10);
          if (!isNaN(current) && current > 0) {
            var next = current - 1;
            el.textContent = String(next);
            if (next === 0) el.style.display = 'none';
          }
        });

        var triggerRemoval = function(swat) {
          if (!swat) return;
          var finish = function() {
            if (window.swymWidgets && typeof window.swymWidgets.updateHeaderCount === 'function') {
              window.swymWidgets.updateHeaderCount();
            }
            try { document.dispatchEvent(new CustomEvent('swym:lists-updated')); } catch (_) {}
          };
          var execute = function(payload) {
            if (typeof swat.removeFromWishList === 'function') {
              swat.removeFromWishList(payload, finish, finish);
            } else if (typeof swat.removeFromList === 'function' && payload.lid) {
              swat.removeFromList({ lid: payload.lid, epi: payload.epi, du: payload.du, callbackFn: finish });
            } else {
              finish();
            }
          };
          if (typeof swat.fetch === 'function') {
            swat.fetch(function(items) {
              var match = (items || []).find(function(it) {
                return (prodId && String(it.empi) === String(prodId)) ||
                       (variantId && String(it.epi) === String(variantId)) ||
                       (prodUrl && it.du && it.du.split('?')[0] === prodUrl.split('?')[0]);
              });
              if (match) {
                execute(match);
              } else {
                execute({ empi: prodId, epi: variantId, du: prodUrl });
              }
            });
          } else {
            execute({ empi: prodId, epi: variantId, du: prodUrl });
          }
        };

        if (window._swat) {
          triggerRemoval(window._swat);
        } else {
          window.SwymCallbacks = window.SwymCallbacks || [];
          window.SwymCallbacks.push(triggerRemoval);
        }
      } else {
        if (prodId) {
          var syncAdd = function() {
            var selector = '.swym-button.product_' + prodId + ', .swym-button[data-product-id="' + prodId + '"]';
            var matchingBtns = document.querySelectorAll(selector);
            matchingBtns.forEach(function(b) {
              b.classList.add('swym-added');
              b.setAttribute('aria-pressed', 'true');
              if (b.parentElement && b.parentElement.classList.contains('main-product__block-wishlist')) {
                b.parentElement.classList.add('swym-block-added');
              }
            });
            if (window.swymWidgets && typeof window.swymWidgets.updateHeaderCount === 'function') {
              window.swymWidgets.updateHeaderCount();
            }
          };
          setTimeout(syncAdd, 350);
          setTimeout(syncAdd, 1000);
        }
      }
    }, true);

    document.addEventListener('swym:item-added', function(e) {
      var prodId = (e.detail && (e.detail.empi || (e.detail.data && (e.detail.data.empi || e.detail.data.productId)))) || null;
      if (prodId) {
        document.querySelectorAll('.swym-button.product_' + prodId + ', .swym-button[data-product-id="' + prodId + '"]').forEach(function(b) {
          b.classList.add('swym-added');
          b.setAttribute('aria-pressed', 'true');
          if (b.parentElement && b.parentElement.classList.contains('main-product__block-wishlist')) {
            b.parentElement.classList.add('swym-block-added');
          }
        });
      }
      if (window.swymWidgets && typeof window.swymWidgets.updateHeaderCount === 'function') {
        window.swymWidgets.updateHeaderCount();
      }
    });

    document.addEventListener('swym:item-removed', function(e) {
      var prodId = (e.detail && (e.detail.empi || (e.detail.data && (e.detail.data.empi || e.detail.data.productId)))) || null;
      if (prodId) {
        document.querySelectorAll('.swym-button.product_' + prodId + ', .swym-button[data-product-id="' + prodId + '"]').forEach(function(b) {
          b.classList.remove('swym-added');
          b.setAttribute('aria-pressed', 'false');
          if (b.parentElement && b.parentElement.classList.contains('main-product__block-wishlist')) {
            b.parentElement.classList.remove('swym-block-added');
          }
        });
      }
      if (window.swymWidgets && typeof window.swymWidgets.updateHeaderCount === 'function') {
        window.swymWidgets.updateHeaderCount();
      }
    });

    function syncQuickViewModal(modalEl) {
      if (!modalEl) modalEl = document.querySelector('.m-product-quickview');
      if (!modalEl) return;

      var qvBtn = modalEl.querySelector('#swym-quick-view, .m-product-quickview-wishlist-button, .swym-add-to-wishlist-view-product');
      var prodId = (qvBtn && (qvBtn.dataset.productId || qvBtn.getAttribute('data-product-id'))) ||
                   modalEl.dataset.productId ||
                   (modalEl.querySelector('[data-product-id]') && modalEl.querySelector('[data-product-id]').dataset.productId);

      if (!prodId) return;

      document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
      document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { productId: prodId } }));
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons('body');
      }

      var plpBtn = document.querySelector('.swym-button.product_' + prodId + ':not(#swym-quick-view), .swym-button[data-product-id="' + prodId + '"]:not(#swym-quick-view)');
      if (qvBtn && plpBtn) {
        var plpVarId = plpBtn.dataset.variantId || plpBtn.getAttribute('data-variant-id');
        if (plpVarId) {
          qvBtn.setAttribute('data-variant-id', plpVarId);
          qvBtn.dataset.variantId = plpVarId;
        }
      }

      var applySync = function() {
        if (!qvBtn) return;
        var currentPlp = document.querySelector('.swym-button.product_' + prodId + ':not(#swym-quick-view), .swym-button[data-product-id="' + prodId + '"]:not(#swym-quick-view)');
        var isAdded = currentPlp ? (currentPlp.classList.contains('swym-added') || currentPlp.getAttribute('aria-pressed') === 'true') : false;
        if (isAdded) {
          qvBtn.classList.add('swym-added');
          qvBtn.setAttribute('aria-pressed', 'true');
          if (qvBtn.parentElement && qvBtn.parentElement.classList.contains('main-product__block-wishlist')) {
            qvBtn.parentElement.classList.add('swym-block-added');
          }
        } else if (currentPlp) {
          qvBtn.classList.remove('swym-added');
          qvBtn.setAttribute('aria-pressed', 'false');
          if (qvBtn.parentElement && qvBtn.parentElement.classList.contains('main-product__block-wishlist')) {
            qvBtn.parentElement.classList.remove('swym-block-added');
          }
        }
      };

      applySync();
      setTimeout(applySync, 100);
      setTimeout(applySync, 300);
      setTimeout(applySync, 600);
      setTimeout(applySync, 1000);

      if (window._swat && typeof window._swat.fetch === 'function') {
        window._swat.fetch(function(items) {
          try {
            var inWishlist = (items || []).some(function(it) {
              return (prodId && String(it.empi) === String(prodId)) ||
                     (qvBtn && qvBtn.dataset.variantId && String(it.epi) === String(qvBtn.dataset.variantId));
            });
            if (inWishlist && qvBtn) {
              qvBtn.classList.add('swym-added');
              qvBtn.setAttribute('aria-pressed', 'true');
              if (qvBtn.parentElement && qvBtn.parentElement.classList.contains('main-product__block-wishlist')) {
                qvBtn.parentElement.classList.add('swym-block-added');
              }
            }
          } catch (_) {}
        });
      }
    }

    var qvObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mut = mutations[i];
        if (mut.addedNodes && mut.addedNodes.length > 0) {
          for (var j = 0; j < mut.addedNodes.length; j++) {
            var node = mut.addedNodes[j];
            if (node.nodeType === 1) {
              if (node.classList && (node.classList.contains('m-product-quickview') || node.classList.contains('m-modal'))) {
                var qv = node.classList.contains('m-product-quickview') ? node : node.querySelector('.m-product-quickview');
                if (qv) syncQuickViewModal(qv);
              } else if (node.querySelector) {
                var qvInside = node.querySelector('.m-product-quickview');
                if (qvInside) syncQuickViewModal(qvInside);
              }
            }
          }
        }
      }
    });

    if (document.body) {
      qvObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        qvObserver.observe(document.body, { childList: true, subtree: true });
      });
    }

    document.addEventListener('quickview:loaded', function(e) {
      syncQuickViewModal();
    });
  }
})();
  